import axios from "axios";
import gerarChaveAPI from "./gerarChaveAPI.js";

const fazerLoginUsuario = async function (cpf, senha) {
  console.log("asdasdasd");
  var usrretorno = {}
  var numeroChave = await gerarChaveAPI()
  if (numeroChave) {
    console.log("entrou fazerLoginUsuario")
    try {
        await axios({
          method: 'get',
          url: `${process.env.VUE_APP_ALIANCA_PROTHEUS}/quallogin/senha/${cpf}/${senha}?api-key=${process.env.VUE_APP_ALIANCA_PROTHEUS_KEY}`,
          headers: {"Token": process.env.VUE_APP_ALIANCA_PROTHEUS_TOKEN_KEY, "Chave": numeroChave },
        }).then(response =>{
          usrretorno = response.data
        })
        .catch(error => {
          usrretorno = undefined
          console.log("error",error)
        })
    } catch (e) {
      console.log("e",e)
    }
}

  return usrretorno
};

export default fazerLoginUsuario;
